<template>
  <tab-layout>
    <payment :cartMembers="cartMembers" :type="'membership'" slot="tabContent" class="tab-pane col-12 col-xl-9 px-0 show active" id="payment" role="tabpanel" aria-label="Payment" />
  </tab-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */

import tabLayout from '@/components/TabLayout'
import memberProfilePayment from '@/components/Payment'

export default {
  name: 'MyMembershipPayment',
  components: {
    'tab-layout': tabLayout,
    payment: memberProfilePayment
  },
  data() {
    return {
      cartMembers: this.$store.state.cartMembers
    }
  },
  mounted() {
    if (this.cartMembers.hasOwnProperty('total') === false) {
      this.$router.push('/my-account/cart')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/MyMembership/MyMembershipPayment.vue